module.exports = __webpack_public_path__ + "static/step-4-0c0957d3034b43e1b0d639dffffee5bf.png";